// extracted by mini-css-extract-plugin
module.exports = {"item":"BreadcrumbItem_item__GfY_h"};